/**
 * This file contains sample financial data that can be exported as JSON for MongoDB import
 * It provides a structured format for official receipts with PHP currency values
 */

// Sample data for official receipts
export const sampleOfficialReceipts = [
  {
    "orNumber": "OR-2023-0001",
    "dateIssued": new Date("2023-01-15T08:30:00Z"),
    "issuedBy": "65f1a2b3c4d5e6f7a8b9c0d2",
    "amount": 2500,
    "paymentMethod": "MANUAL",
    "remarks": "Payment for CSAW permit application",
    "receiptImage": "Official-Receipt.jpg"
  },
  {
    "orNumber": "OR-2023-0002",
    "dateIssued": new Date("2023-01-20T10:15:00Z"),
    "issuedBy": "65f1a2b3c4d5e6f7a8b9c0d2",
    "amount": 3000,
    "paymentMethod": "MANUAL",
    "remarks": "Payment for COV permit application",
    "receiptImage": "Official-Receipt.jpg"
  },
  {
    "orNumber": "OR-2023-0003",
    "dateIssued": new Date("2023-02-05T09:45:00Z"),
    "issuedBy": "65f1a2b3c4d5e6f7a8b9c0d2",
    "amount": 4500,
    "paymentMethod": "MANUAL",
    "remarks": "Payment for PTPR permit application",
    "receiptImage": "Official-Receipt.jpg"
  },
  {
    "orNumber": "OR-2023-0004",
    "dateIssued": new Date("2023-02-18T14:20:00Z"),
    "issuedBy": "65f1a2b3c4d5e6f7a8b9c0d2",
    "amount": 5000,
    "paymentMethod": "MANUAL",
    "remarks": "Payment for PLTP permit application",
    "receiptImage": "Official-Receipt.jpg"
  },
  {
    "orNumber": "OR-2023-0005",
    "dateIssued": new Date("2023-03-10T11:30:00Z"),
    "issuedBy": "65f1a2b3c4d5e6f7a8b9c0d2",
    "amount": 3500,
    "paymentMethod": "MANUAL",
    "remarks": "Payment for CSAW permit application",
    "receiptImage": "Official-Receipt.jpg"
  },
  {
    "orNumber": "OR-2023-0006",
    "dateIssued": new Date("2023-03-22T13:45:00Z"),
    "issuedBy": "65f1a2b3c4d5e6f7a8b9c0d2",
    "amount": 4000,
    "paymentMethod": "MANUAL",
    "remarks": "Payment for COV permit application",
    "receiptImage": "Official-Receipt.jpg"
  },
  {
    "orNumber": "OR-2023-0007",
    "dateIssued": new Date("2023-04-05T10:00:00Z"),
    "issuedBy": "65f1a2b3c4d5e6f7a8b9c0d2",
    "amount": 6000,
    "paymentMethod": "MANUAL",
    "remarks": "Payment for PLTCP permit application",
    "receiptImage": "Official-Receipt.jpg"
  },
  {
    "orNumber": "OR-2023-0008",
    "dateIssued": new Date("2023-04-18T09:30:00Z"),
    "issuedBy": "65f1a2b3c4d5e6f7a8b9c0d2",
    "amount": 5500,
    "paymentMethod": "MANUAL",
    "remarks": "Payment for TCEBP permit application",
    "receiptImage": "Official-Receipt.jpg"
  },
  {
    "orNumber": "OR-2023-0009",
    "dateIssued": new Date("2023-05-07T14:15:00Z"),
    "issuedBy": "65f1a2b3c4d5e6f7a8b9c0d2",
    "amount": 3800,
    "paymentMethod": "MANUAL",
    "remarks": "Payment for CSAW permit application",
    "receiptImage": "Official-Receipt.jpg"
  },
  {
    "orNumber": "OR-2023-0010",
    "dateIssued": new Date("2023-05-20T11:45:00Z"),
    "issuedBy": "65f1a2b3c4d5e6f7a8b9c0d2",
    "amount": 4200,
    "paymentMethod": "MANUAL",
    "remarks": "Payment for COV permit application",
    "receiptImage": "Official-Receipt.jpg"
  },
  {
    "orNumber": "OR-2023-0011",
    "dateIssued": new Date("2023-06-03T10:30:00Z"),
    "issuedBy": "65f1a2b3c4d5e6f7a8b9c0d2",
    "amount": 7000,
    "paymentMethod": "MANUAL",
    "remarks": "Payment for PLTP permit application",
    "receiptImage": "Official-Receipt.jpg"
  },
  {
    "orNumber": "OR-2023-0012",
    "dateIssued": new Date("2023-06-22T13:00:00Z"),
    "issuedBy": "65f1a2b3c4d5e6f7a8b9c0d2",
    "amount": 6500,
    "paymentMethod": "MANUAL",
    "remarks": "Payment for PLTCP permit application",
    "receiptImage": "Official-Receipt.jpg"
  },
  {
    "orNumber": "OR-2023-0013",
    "dateIssued": new Date("2023-07-08T09:15:00Z"),
    "issuedBy": "65f1a2b3c4d5e6f7a8b9c0d2",
    "amount": 5200,
    "paymentMethod": "MANUAL",
    "remarks": "Payment for TCEBP permit application",
    "receiptImage": "Official-Receipt.jpg"
  },
  {
    "orNumber": "OR-2023-0014",
    "dateIssued": new Date("2023-07-19T14:30:00Z"),
    "issuedBy": "65f1a2b3c4d5e6f7a8b9c0d2",
    "amount": 4800,
    "paymentMethod": "MANUAL",
    "remarks": "Payment for PTPR permit application",
    "receiptImage": "Official-Receipt.jpg"
  },
  {
    "orNumber": "OR-2023-0015",
    "dateIssued": new Date("2023-07-28T11:00:00Z"),
    "issuedBy": "65f1a2b3c4d5e6f7a8b9c0d2",
    "amount": 5000,
    "paymentMethod": "MANUAL",
    "remarks": "Payment for COV permit application",
    "receiptImage": "Official-Receipt.jpg"
  }
];

/**
 * Function to generate a MongoDB-compatible JSON file for importing
 * @returns {string} JSON string ready for MongoDB import
 */
export const generateMongoDBImportJSON = () => {
  return JSON.stringify(
    sampleOfficialReceipts.map((receipt, index) => ({
      _id: { $oid: `65f1a2b3c4d5e6f7a8b9c${index.toString().padStart(3, '0')}` },
      orNumber: receipt.orNumber,
      dateIssued: { $date: receipt.dateIssued.toISOString() },
      issuedBy: { $oid: receipt.issuedBy },
      amount: receipt.amount,
      paymentMethod: receipt.paymentMethod,
      remarks: receipt.remarks,
      receiptImage: receipt.receiptImage
    })),
    null,
    2
  );
};

// Export a function to get the total financial statistics
export const getFinancialStats = () => {
  const total = sampleOfficialReceipts.reduce((sum, receipt) => sum + receipt.amount, 0);

  // For demo purposes, we'll consider:
  // - Receipts from the last month as "pending"
  // - A fixed percentage as "overdue"
  // - The rest as "paid"
  const lastMonthDate = new Date();
  lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);

  const pending = sampleOfficialReceipts
    .filter(receipt => receipt.dateIssued > lastMonthDate)
    .reduce((sum, receipt) => sum + receipt.amount, 0);

  const overdue = Math.round(total * 0.1); // 10% of total as overdue
  const paid = total - pending - overdue;

  return {
    total,
    paid,
    pending,
    overdue,
    monthlyGrowth: 8 // Sample growth percentage
  };
};

// Export a formatted version for direct use in MongoDB Compass
export const getMongoDBCompassFormat = () => {
  const docs = sampleOfficialReceipts.map((receipt, index) => ({
    orNumber: receipt.orNumber,
    dateIssued: { $date: receipt.dateIssued.toISOString() },
    issuedBy: { $oid: receipt.issuedBy },
    amount: receipt.amount,
    paymentMethod: receipt.paymentMethod,
    remarks: receipt.remarks,
    receiptImage: receipt.receiptImage
  }));

  return docs;
};